import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import Vaccine from './VaccinationApp';

// Browser Router in a separate file so we can test easier
const App = () => (
    <Router basename="/ctx">
        <Vaccine />
    </Router>
);

const container = document.getElementById('react-root');
const root = createRoot(container);

root.render(
    <StrictMode>
        <App />
    </StrictMode>
);
